export default __webpack_public_path__ + "static/dev-82c5efd067a33cc8ce2edc2beac81f68.gif";